import React/*, {useEffect, useState}*/ from "react"
// import ReactModal from 'react-modal'
import "./host2021.css"
// import anime from 'animejs/lib/anime.es.js';

const Host = ( { sponsors, description }) => {

    // const [learnMoreModalState,setLearnMoreModalState] = useState(false)
    // const [animation, setAnimation] = useState()
    // const [animationPlayed, setAnimationPlayed] = useState(false)

    // const showLearnMoreModal = () => setLearnMoreModalState(true)
    // const hideLearnMoreModal = () => setLearnMoreModalState(false)


    return (
        <section className="host2021" id="Host">
            <div className="containfix">
                    <div>
                        <h1>HOST AN <span className="aigreen">AI</span> WEEK EVENT</h1>
                        <p className="underabout2021">AI Week is the best platform to reach your target audience by hosting an event that best suits your needs and goals. Whether it be a webinar, panel, tech demo, networking event, career fair or anything else! AI Week can help you showcase how the power of AI will improve services, enhance efficiency, and create a more equitable and prosperous future.
                        </p>


                    </div>

            </div>

        </section>

    )
}

export default Host
